(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash"], factory);
	else if(typeof exports === 'object')
		exports["viewer-script"] = factory(require("lodash"));
	else
		root["viewer-script"] = factory(root["_"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 